import React from "react";
import { MenuItem, Divider } from "@mui/material";
import { FieldSelect } from "./FieldSelect";
import FormRow from "./row";
import FieldInput from "./FieldInput";
import { FieldDatePicker } from "./FieldDatePicker";
import FieldCheckbox from "./FieldCheckbox";
import BrandActivities from "./BrandActivities";

export default function FormActivity(props) {
  return (
    <>
      <FormRow count={2}>
        <FieldSelect name="productionStatus" label="Production Status">
          <MenuItem value="Open">Open</MenuItem>
          <MenuItem value="Testing">Testing</MenuItem>
          <MenuItem value="In Production">In Production</MenuItem>
        </FieldSelect>
        <FieldInput name="totalIncome" label="Total Income" />
      </FormRow>

      <Divider />

      <FormRow count={2}>
        <FieldInput name="totalProjects" label="Total Projects" />
        <FieldInput name="reviewsFilmed" label="Reviews Filmed" />
      </FormRow>

      <FormRow count={2}>
        <FieldInput name="how-tosFilmed" label="How-tos Filmed" />
        <FieldInput name="classesFilmed" label="Classes Filmed" />
      </FormRow>

      <FormRow count={2}>
        <FieldInput
          name="totalVideosPublished"
          label="Total Videos Published"
        />
        <FieldDatePicker
          name="lastProductionDate"
          label="Last Production Date"
        />
      </FormRow>

      <FormRow count={2}>
        <FieldInput
          name="daysSinceLastProduction"
          label="Days Since Last Production"
          InputProps={{
            readOnly: true,
          }}
        />
        <FieldInput name="totalClients" label="Total Clients" />
      </FormRow>

      <FieldCheckbox name="isWebProfileComplete" text="Web Profile Complete" />

      <FieldCheckbox name="proSpotlight" text="Pro Spotlight" />

      <BrandActivities {...props} />
    </>
  );
}
